import { render, staticRenderFns } from "./Codechange.vue?vue&type=template&id=a9b98fb4&scoped=true&"
import script from "./Codechange.vue?vue&type=script&lang=js&"
export * from "./Codechange.vue?vue&type=script&lang=js&"
import style0 from "./Codechange.vue?vue&type=style&index=0&id=a9b98fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b98fb4",
  null
  
)

export default component.exports